// Simple module to track if a resize drag operation is happening
let isDragging = false;
let resetTimer = null;

export const setDragging = (value) => {
  isDragging = value;

  // Clear any existing timer
  if (resetTimer) {
    clearTimeout(resetTimer);
    resetTimer = null;
  }

  // If we're setting to true, schedule an auto-reset after 1 second
  if (value === true) {
    resetTimer = setTimeout(() => {
      isDragging = false;
    }, 500);
  }
};

export const getDragging = () => {
  return isDragging;
};
